import { compose, withProps, withHandlers, setPropTypes } from "recompose";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { createHocBase } from "app/utils";
import hash from "object-hash";
import PropTypes from "prop-types";
import * as actions from "./actions";
import { COUNT_COMMENTS } from "./constants";

const createCommentActions = dispatch => bindActionCreators(actions, dispatch);

export const connectCommentActions = connect(
  null,
  createCommentActions
);

const selectCommentListState = (state, props) => {
  const params = props.commentListParams;
  return {
    commentList: state.comments[params.id]
  };
};

export const connectCommentListState = connect(selectCommentListState);

const listConditional = props => {
  const { listComments, commentListParams, commentList } = props;
  if (commentListParams && !commentList) {
    listComments(commentListParams);
  }
};

export const fetchCommentList = Component =>
  class extends createHocBase(Component) {
    componentDidMount(prevProps) {
      listConditional(this.props);
    }
    componentDidUpdate(prevProps) {
      const params = this.props.commentListParams;
      const prevParams = prevProps.commentListParams;
      if (prevParams.id === params.id) return;
      listConditional(this.props);
    }
  };

const createCommentListParams = props => {
  const { resourceType, resourceId } = props;
  const id = hash({ resourceType, resourceId });
  const commentListParams = { id, resourceType, resourceId };
  return {
    commentListParams
  };
};

const updateCommentList = props => () => {
  const { listComments, commentListParams } = props;
  listComments(commentListParams);
};

export const withCommentList = compose(
  setPropTypes({
    resourceType: PropTypes.string.isRequired,
    resourceId: PropTypes.string.isRequired
  }),
  withProps(createCommentListParams),
  connectCommentActions,
  connectCommentListState,
  withHandlers({
    updateCommentList
  }),
  fetchCommentList
);

const selectCommentCountState = (state, props) => {
  const params = props.commentCountParams;
  return {
    commentCount: state.comments[params.id]
  };
};

export const connectCommentCountState = connect(selectCommentCountState);

const countConditional = props => {
  const { countComments, commentCountParams, commentCount } = props;
  if (commentCountParams && !commentCount) {
    countComments(commentCountParams);
  }
};

export const fetchCommentCount = Component =>
  class extends createHocBase(Component) {
    componentDidMount(prevProps) {
      countConditional(this.props);
    }
    componentDidUpdate(prevProps) {
      const params = this.props.commentCountParams;
      const prevParams = prevProps.commentCountParams;
      if (prevParams.id === params.id) return;
      countConditional(this.props);
    }
  };

const createCommentCountParams = props => {
  const { resourceType, resourceId } = props;
  const actionType = `${COUNT_COMMENTS}`;
  const id = hash({ resourceType, resourceId, actionType });
  const commentCountParams = { id, resourceType, resourceId, actionType };
  return {
    commentCountParams
  };
};

const updateCommentCount = props => () => {
  const { countComments, commentCountParams } = props;
  countComments(commentCountParams);
};

export const withCommentCount = compose(
  setPropTypes({
    resourceType: PropTypes.string.isRequired,
    resourceId: PropTypes.string.isRequired
  }),
  withProps(createCommentCountParams),
  connectCommentActions,
  connectCommentCountState,
  withHandlers({
    updateCommentCount
  }),
  fetchCommentCount
);



// WEBPACK FOOTER //
// ./src/app/comments/hocs.js